<template>
  <i class="fas fa-trash pointer text-danger" @click="onClick" b-v-tooltip.hover :title="$lang.Common.Tooltip.ButtonDelete"></i>
</template>

<script>
export default {
  name: 'ActionsCellRenderer',
  methods: {
    onClick () {
      this.params.onClick(this.params)
    }
  }
}
</script>

<style scoped>
i {
  font-size: 1rem;
}
</style>



// WEBPACK FOOTER //
// src/views/private/operational/pci/coptype/actionsCellRenderer.vue